import * as angular from 'angular';

import { IDispatcherService, IDispatcher, IUserActionsService } from '../../stateManagement';
import { ApplicationUserViewModel } from '../../models';

export interface IUserStoreService {
    getOne: (guid: string) => angular.IPromise<ApplicationUserViewModel>;
    getAll: (force?: boolean) => angular.IPromise<ApplicationUserViewModel[]>;
}

export interface IUserActionDispatcherService extends IDispatcherService<IUserStoreService> { }

export class UserActionDispatcherService implements IUserActionDispatcherService {
    static serviceId = 'userActionDispatcherService';

    static $inject = ['userActionsService'];

    constructor(private _actionService: IUserActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<IUserStoreService> {
        const actionService = this._actionService;

        return {
            dispatcher: {
                getOne: (guid: string) => dispatch(actionService.getOne(guid)),
                getAll: (force?: boolean) => dispatch(actionService.getAll(force))
            }
        };
    }
}